import articleStates from "~/assets/data/articleState.json";
import { type FullPrice, type Price, NeoStoreAvailability, NeoStoreButtonAction } from "@expert/types";
import type { StateItem } from "~~/models/ExpArticle/exp_ArticleState";
import { CtaButtonType, type CtaButtonState } from "~~/models/CTA/CtaButton";

export const isArticleAvailableInStore = (price: Price | undefined): boolean => {
    return price?.storeAvailability
        ? ![NeoStoreAvailability.SOLD_OUT, NeoStoreAvailability.NOT_AVAILABLE, NeoStoreAvailability.NOT_IN_STORE].includes(price.storeAvailability)
        : false;
}

export const isArticleWithSpecialStoreAction = (price: Price | undefined): boolean => {
    return price?.storeButtonAction
        ? [NeoStoreButtonAction.SEARCH_STORE].includes(price.storeButtonAction)
        : false;
}

export const isArticleAvailableOnline = (price: Price | undefined): boolean => {
    return price?.onlineAvailability
        ? ![NeoStoreAvailability.SOLD_OUT, NeoStoreAvailability.NOT_AVAILABLE, NeoStoreAvailability.ONLY_IN_STORE].includes(price.onlineAvailability)
        : false;
}

export const isArticleAvailableInStoreOrOnline = (price: Price | undefined): boolean => {
    return isArticleAvailableInStore(price) || isArticleAvailableOnline(price);
}

export const hasAlternativeAvailability = (alternativeAvailabilityForStores) => {
  return (
    alternativeAvailabilityForStores &&
    Object.keys(alternativeAvailabilityForStores).length > 0
  );
};

export const getArticleStates = (price: FullPrice | undefined, buttonType?: CtaButtonType): CtaButtonState => {
    const ctaState: CtaButtonState = {
        storeState: {},
        onlineState: {},
        redirectState: {},
    };

    ctaState.storeState.disabled = !isArticleAvailableInStore(price) && !isArticleWithSpecialStoreAction(price);
    ctaState.onlineState.disabled = !isArticleAvailableOnline(price);

    if (price?.storeAvailability) {
        ctaState.storeState['availabilityState'] = getStateItem('storeAvailability', price.storeAvailability, price);
    }
    if (price?.storeButtonAction) {
        ctaState.storeState['buttonActionState'] = getStateItem('storeButtonAction', price.storeButtonAction, price);
    }

    if (price?.onlineAvailability) {
        ctaState.onlineState['availabilityState'] = getStateItem('onlineAvailability', price.onlineAvailability, price);
    }
    if (price?.onlineButtonAction) {
        ctaState.onlineState['buttonActionState'] = getStateItem('onlineButtonAction', price.onlineButtonAction, price);
    }

    if (buttonType == CtaButtonType.REDIRECT || buttonType == CtaButtonType.CATEGORY_ONLINE && price?.onlineAvailability) {
        ctaState.redirectState['availabilityState'] = getStateItem('onlineAvailability', price.onlineAvailability, price);
    }
    if (buttonType == CtaButtonType.REDIRECT || buttonType == CtaButtonType.CATEGORY_ONLINE) {
        ctaState.redirectState['buttonActionState'] = getStateItem('redirectButtonAction', "REDIRECT", price);
    }

    return ctaState;
}

const getStateItem = (field: string, key: string, price: FullPrice | undefined): StateItem | undefined => {
    const stateArray: Array<StateItem> = articleStates?.[field] ?? [];
    const stateItem: StateItem | undefined = stateArray.find((item: StateItem) => item.state === key);

    if (stateItem) {
        stateItem.textForm = stateItem.textForm.replace("$days", price?.minStoreDelivery + " - " + price?.maxStoreDelivery)
    }

    return stateItem;
}